




































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import { DocumentSelectorMixin } from "./mixins";
import { DocumentSelectorListColumnSetting } from "../../../domain/document/selectors";
import { DocumentSummary, DocumentTypeKinds } from "../../../domain/document";
import {
  IStyleDocumentListSelectorStyleListColumnConfiguration,
  IStyleDocumentListSelectorStyleListColumnPaddingConfiguration,
} from "../../../domain/configuration";

@Component({
  components: {
    InfiniteLoading,
  },
})
export default class DocumentSelectorListStyle extends Mixins(DocumentSelectorMixin) {

  data(): any {
    return {
      defaultColumns: [
        {
          property: "contentDateTime",
          width: 120,
          title: "文書日付",
          className: "content-datetime",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("contentDateTime"),
          toColumnValue: (s: DocumentSummary, index: number) => this.toDateString(s.contentDateTime),
        },
        {
          property: "patientNo",
          width: 120,
          title: "患者番号",
          className: "patient-no",
          isPatientColumn: true,
          style: (s: DocumentSummary) => this.toSettingStyle("patientNo"),
          toColumnValue: (s: DocumentSummary, index: number) => s.patientNo,
        },
        {
          property: "patientName",
          width: 150,
          title: "患者名",
          className: "patient-name",
          isPatientColumn: true,
          style: (s: DocumentSummary) => this.toSettingStyle("patientName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.patientName,
        },
        {
          property: "department",
          width: 150,
          title: this.$wording.common.department,
          className: "department",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("department"),
          toColumnValue: (s: DocumentSummary, index: number) => s.department.name,
        },
        {
          property: "documentName",
          width: 150,
          title: this.$wording.format.attributes.name + "名",
          className: "document-name",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("documentName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.documentName,
        },
        {
          property: "companyName",
          width: 150,
          title: this.$wording.format.attributes.company + "名",
          className: "company-name",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("companyName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.companyName,
        },
        {
          property: "createStaffName",
          width: 150,
          title: "作成者",
          className: "create-staff-name",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("createStaffName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.createStaffName,
        },
        {
          property: "orderUserName",
          width: 150,
          title: "指示者",
          className: "order-user-name",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("orderUserName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.orderUserName,
        },
        {
          property: "attendingUserName",
          width: 150,
          title: "指導者",
          className: "attending-user-name",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("attendingUserName"),
          toColumnValue: (s: DocumentSummary, index: number) => s.attendingUserName,
        },
        {
          property: "createdDateTime",
          width: 120,
          title: "更新日時",
          className: "create-datetime",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("createdDateTime"),
          toColumnValue: (s: DocumentSummary, index: number) => this.toDateString(s.createdDateTime) + "\r\n" + this.toTimeString(s.createdDateTime),
        },
        {
          property: "published",
          width: 100,
          title: "発行状態",
          className: "published",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toPublishedStype(s),
          toColumnValue: (s: DocumentSummary, index: number) => s.published ? "発行済" : "未発行",
        },
        {
          property: "publishedCount",
          width: 100,
          title: "印刷履歴件数",
          className: "published-count",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("publishedCount"),
          toColumnValue: (s: DocumentSummary, index: number) => s.publishedCount + "件",
        },
        {
          property: "describedMethod",
          width: 140,
          title: "記載方法",
          className: "described-method",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("describedMethod"),
          toColumnValue: (s: DocumentSummary, index: number) => this.toDescribedMethod(s),
        },
        {
          property: "note",
          width: 150,
          title: this.$wording.document.note,
          className: "note",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("note"),
          toColumnValue: (s: DocumentSummary, index: number) => s.note,
        },
        {
          property: "edition",
          width: 80,
          title: "版数",
          className: "edition",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("edition"),
          toColumnValue: (s: DocumentSummary, index: number) => "第" + s.edition + "版",
        },
        {
          property: "id",
          width: 100,
          title: "文書ID",
          className: "id",
          isPatientColumn: false,
          style: (s: DocumentSummary) => this.toSettingStyle("id"),
          toColumnValue: (s: DocumentSummary, index: number) => s.id,
        },
      ],
      columnsStyleSettingsCommonKey: "*",
    };
  }
  defaultColumns: DocumentSelectorListColumnSetting[];
  columnsStyleSettingsCommonKey: string;

  get displayColumns(): DocumentSelectorListColumnSetting[] {
    const displayColumnNames = this.$configuration.behavior.document.list.selector.style.list.columns;
    const columns = (displayColumnNames && 0 < displayColumnNames.length)
      ? Enumerable.from(displayColumnNames)
        .select(i => this.getColumnSetting(i))
        .where(c => !!c).toArray()
      : this.defaultColumns;
    
    return this.shouldShowPatientColumns
      ? columns
      : columns.filter(c => !c.isPatientColumn);
  }

  private getColumnSetting(name: string): DocumentSelectorListColumnSetting {
     return Enumerable.from(this.defaultColumns).firstOrDefault(c => c.property === name);
  }

  toDescribedMethod(summary: DocumentSummary): string {
    return Enumerable.from([
        this.toDocumentStatusText(summary),
        this.toDocumentTypeText(summary),
      ])
      .where(t => !!t)
      .toArray()
      .join(" ");
  }

  private toDocumentStatusText(summary: DocumentSummary): string {
    if (summary.isDeleted) { return "削除済み"; }
    if (summary.isTemporary) { return "一時保存"; }
    if (summary.isFixed) { return "編集不可"; }
    // TODO: ワークフロー文書については医師記載進捗を過ぎたかどうかで表示文言を切り替える機能があったほうが良さそう
    return (summary.documentType !== DocumentTypeKinds.Normal)
      ? ""
      : this.$configuration.wording.document.list.status.normal;
  }

  private toDocumentTypeText(summary: DocumentSummary): string {
    // TODO: ワークフロー依頼書が表示出ていない（カードのほうも出ていない）
    return this.isWorkflowDocument(summary.documentType)
      ? "ワークフロー文書"
      : "";
  }

  toPublishedStype(summary: DocumentSummary): any {
    const publishedStyle = {
      color: summary.published ? "#606266" : this.unpublishedColor,
    };
    return { ...publishedStyle, ...this.toSettingStyle("published") };
  }

  toSettingStyle(key: string): any {
    const style = {
      padding: this.toColumnPadding(key),
      fontSize: this.toColumnFontSize(key),
    };
    const noWrapStyle = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };
    return this.shouldWrap(key)
      ? style
      : { ...style, ...noWrapStyle };
  }

  get columnsStyleSettings(): { [key: string]: IStyleDocumentListSelectorStyleListColumnConfiguration } {
    return this.$configuration.style.document.list.selector.style.list.columns;
  }

  toColumnWidth(key: string): number {
    return this.columnsStyleSettings[key] && this.columnsStyleSettings[key].width
      ? this.$configuration.style.document.list.selector.style.list.columns[key].width
      : this.columnsStyleSettings[this.columnsStyleSettingsCommonKey].width;
  }

  toColumnPadding(key: string): string {
    return this.columnsStyleSettings[key] && this.columnsStyleSettings[key].padding
      ? this.toColumnPaddingString(this.$configuration.style.document.list.selector.style.list.columns[key].padding)
      : this.toColumnPaddingString(this.columnsStyleSettings[this.columnsStyleSettingsCommonKey].padding);
  }

  toColumnPaddingString(padding: IStyleDocumentListSelectorStyleListColumnPaddingConfiguration): string {
    return padding.topAndBottom + "px " + padding.leftAndRight + "px";
  }

  toColumnFontSize(key: string): string {
    return this.columnsStyleSettings[key] && this.columnsStyleSettings[key].fontSize
      ? this.$configuration.style.document.list.selector.style.list.columns[key].fontSize + "px"
      : this.columnsStyleSettings[this.columnsStyleSettingsCommonKey].fontSize + "px";
  }

  toTooltip(column: DocumentSelectorListColumnSetting, summary: DocumentSummary, index: number): string {
    return this.shouldWrap(column.property)
      ? ""
      : column.toColumnValue(summary, index);
  }

  shouldWrap(key: string): boolean {
    return this.columnsStyleSettings[key] && this.columnsStyleSettings[key].shouldWrap !== undefined
      ? this.columnsStyleSettings[key].shouldWrap
      : this.columnsStyleSettings[this.columnsStyleSettingsCommonKey].shouldWrap;
  }
}
